import React from "react";
import { FaHardHat, FaGasPump, FaCogs, FaWeight, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

function ConstructionEquipmentDetails({ product }) {
    if (!product) return <p className="productspec-error">Məlumat tapılmadı.</p>;

    const getStatus = (val, yes = "Bəli", no = "Xeyr") =>
        val === true ? yes : val === false ? no : "Bilinmir";

    const specs = [
        { label: "Şəhər", value: product.city, icon: <FaHardHat /> },
        { label: "Kateqoriya", value: product.categoryName },
        { label: "Sub-kateqoriya", value: product.subCategoryName },
        { label: "Marka", value: product.brandName },
        { label: "Model", value: product.modelName },
        { label: "İstehsal ili", value: product.year },
        { label: "Yanacaq növü", value: product.fuelTypeName, icon: <FaGasPump /> },
        { label: "Motor gücü", value: product.horsePower ? `${product.horsePower} HP` : null },
        { label: "Mühərrik gücü", value: product.enginePower },
        { label: "Mühərrik həcmi", value: product.engineVolume },
        { label: "İş saatı", value: product.workingHours ? `${product.workingHours} saat` : null },
        { label: "Qaldırma qabiliyyəti", value: product.liftingCapacity ? `${product.liftingCapacity} kq` : null, icon: <FaWeight /> },
        { label: "Ölçülər", value: product.dimensions },
        { label: "Sürət qutusu", value: product.transmission, icon: <FaCogs /> },
        { label: "Ötürücü tipi", value: product.driveType },
        { label: "Rəng", value: product.color },
        { label: "Oturacaq sayı", value: product.seatCount },
        { label: "Qapı sayı", value: product.doorCount },
        { label: "Yeni", value: getStatus(product.isNew), status: product.isNew },
        { label: "Qəzalı olub", value: getStatus(product.isAccidented), status: product.isAccidented === false },
        { label: "Texniki baxış", value: getStatus(product.hasTechnicalInspection), status: product.hasTechnicalInspection },
        { label: "Sığorta", value: getStatus(product.hasInsurance), status: product.hasInsurance },
        { label: "Sahib sayı", value: product.ownerCount },
        { label: "VIN nömrəsi", value: product.vin },
        { label: "Bazar ölkəsi", value: product.marketCountry },
        { label: "İstifadə bölgəsi", value: product.usageRegion }
    ];

    return (
        <div className="productspec-container productspec-container--automotive">
            <div className="productspec-header">
                <FaHardHat className="productspec-header__icon" />
                <h3 className="productspec-header__title">Tikinti Texnikası Məlumatları</h3>
            </div>

            <div className="productspec-grid">
                {specs.map((spec, index) => {
                    if (!spec.value || spec.value === "Bilinmir") return null;
                    
                    return (
                        <div key={index} className="productspec-item">
                            {spec.icon && <span className="productspec-item__icon">{spec.icon}</span>}
                            <div className="productspec-item__content">
                                <span className="productspec-item__label">{spec.label}</span>
                                <span className={`productspec-item__value ${spec.status !== undefined ? (spec.status ? 'productspec-item__value--success' : 'productspec-item__value--danger') : ''}`}>
                                    {spec.status !== undefined && (
                                        spec.status ? <FaCheckCircle className="productspec-status-icon productspec-status-icon--success" /> : <FaTimesCircle className="productspec-status-icon productspec-status-icon--danger" />
                                    )}
                                    {spec.value}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>

            {product.description && (
                <div className="productspec-description">
                    <h4 className="productspec-description__title">Əlavə Təsvir</h4>
                    <p className="productspec-description__text">{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default ConstructionEquipmentDetails;